import { Plus } from '@griply/assets';
import { GoalType } from '@griply/types';
import React from 'react';
import { AddGoalMenuItems } from 'shared/components/connected/add-goal-menu-items';
import { MoveGoalMenuItem } from 'shared/components/ui/move-goal-menu-item';
import { PopupMenuList } from 'shared/components/ui/popup-menu';
import { Goal } from 'shared/types/goal';

export type MoveGoalListProps = {
  goal: Goal;
  onClose: () => void;
  openGoalSelect: () => void;
};

export const MoveGoalList: React.FC<MoveGoalListProps> = ({
  goal,
  onClose,
  openGoalSelect,
}) => {
  const isProject = goal.type === GoalType.Project;

  return (
    <PopupMenuList hasBottomBorder>
      <MoveGoalMenuItem onSelect={openGoalSelect} />
      {!isProject && (
        <AddGoalMenuItems parentIds={[goal.id]} onClose={onClose} icon={Plus} />
      )}
    </PopupMenuList>
  );
};
